
import { AdsLandingPage } from "@/components/landing/AdsLandingPage";

const AdsLanding = () => {
  return <AdsLandingPage />;
};

export default AdsLanding;
